export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12020.d79fd0ec.jpg";